var scope_0 = require('/Users/vincentliu/Desktop/redso/link823-2020-Q3/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/45d98bfe137562bcde976afe6c7da7e3.js').default;
var scope_1 = require('/Users/vincentliu/Desktop/redso/link823-2020-Q3/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/50bb7e377d3c139195d58bbc5f5806d1.js').default;
var scope_2 = require('/Users/vincentliu/Desktop/redso/link823-2020-Q3/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/54251990c0dff3bbb3f668f1c31cf59d.js').default;
var scope_3 = require('/Users/vincentliu/Desktop/redso/link823-2020-Q3/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/5c41960e7930add0cb10b51d23b6b61b.js').default;
var scope_4 = require('/Users/vincentliu/Desktop/redso/link823-2020-Q3/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/8788c0bccfa36fc01ee29fd5d45c6a41.js').default;
var scope_5 = require('/Users/vincentliu/Desktop/redso/link823-2020-Q3/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/95afc7e3ece9fb4d4bcf6cede4a0d2c2.js').default;
var scope_6 = require('/Users/vincentliu/Desktop/redso/link823-2020-Q3/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6 )
    